const fileNameExtensionRegex = /\.[a-z0-9]+$/i;

const extractFileNameExtension = (fileName: string) => {
  const match = fileName.match(fileNameExtensionRegex);

  return match ? match[0] : null;
};

const removeFileNameExtension = (fileName: string) => {
  return fileName.replace(fileNameExtensionRegex, '');
};

const sanitizeFileName = (
  raw: string,
  options?: {
    replace?: {
      pattern: RegExp;
      replacement: string;
    }[];
  }
): string => {
  let name = raw;

  try {
    // decode only if it looks encoded (presence of % or +)
    if (/%[0-9A-Fa-f]{2}/.test(name) || /\+/.test(name)) {
      name = decodeURIComponent(name);
    }
  } catch {
    // ignore decode errors and keep original
  }

  // Replace '+' (often used for spaces in query encoding) with space
  name = name.replace(/\+/g, ' ');

  // Trim and collapse whitespace
  name = name.trim().replace(/\s+/g, ' ');

  // Remove unsafe characters
  name = name.replace(/[<>:"\\|?*\x00-\x1F]/g, '');

  // Apply custom replacements
  if (options?.replace) {
    options.replace.forEach(({ pattern, replacement }) => {
      name = name.replace(pattern, replacement);
    });
  }

  return name;
};

const hasOnlyExtension = (fileName: string): boolean => {
  const trimmed = fileName.trim();

  // File has only extension if:
  // 1. It starts with a dot
  // 2. It has at least one more character (the extension)
  // 3. There are no other dots after the first one (meaning no filename portion)
  return trimmed.startsWith('.') && trimmed.length > 1 && trimmed.indexOf('.', 1) === -1;
};

export default {
  extractFileNameExtension,
  removeFileNameExtension,
  sanitizeFileName,
  hasOnlyExtension,
};
